import type { ReelRollTuning } from "./ReelMotionTuning";
import type { GridAudioSoundPlayer } from "@slot/presentation";

/**
 * The reel roll loops: the whole-spin roll from the first scroll to the last land, and the
 * anticipation roll over a teasing reel (the spin roll ducked under it). Every call is a no-op
 * without tuning or without loop support on the audio port.
 */
export class ReelRollAudio {
  public constructor(
    private readonly audio: GridAudioSoundPlayer | undefined,
    private readonly roll: ReelRollTuning | undefined,
  ) {}

  public startSpin(): void {
    if (this.roll?.spinSoundId) this.audio?.startLoop?.(this.roll.spinSoundId);
  }

  public stopSpin(): void {
    if (this.roll?.spinSoundId) this.audio?.stopLoop?.(this.roll.spinSoundId);
  }

  public startAnticipation(): void {
    const roll = this.roll;
    if (!roll) return;
    if (roll.anticipationSoundId) this.audio?.startLoop?.(roll.anticipationSoundId);
    if (roll.spinSoundId) this.audio?.setLoopGainScale?.(roll.spinSoundId, roll.anticipationDuckScale ?? 1);
  }

  public stopAnticipation(): void {
    const roll = this.roll;
    if (!roll) return;
    if (roll.anticipationSoundId) this.audio?.stopLoop?.(roll.anticipationSoundId);
    if (roll.spinSoundId) this.audio?.setLoopGainScale?.(roll.spinSoundId, 1);
  }

  /** Every loop off — the safety net on abort, recovery and a new spin. */
  public stopAll(): void {
    this.stopSpin();
    if (this.roll?.anticipationSoundId) this.audio?.stopLoop?.(this.roll.anticipationSoundId);
  }
}
